module.exports = __webpack_public_path__ + "static/media/shape_2.1304ae3b.png";